<template>
  <el-upload class="uploader" action="#" :http-request="uploadAttach" multiple :before-upload="beforeUpload" :show-file-list="false">
    <el-button type="primary" icon="el-icon-upload2">上传附件</el-button>
  </el-upload>
</template>
<script>
import axios from "axios";
import { dateFormat } from "@/utils/util";
import { ContractApis } from "@/apis";

export default {
  name: "upload-attach",
  data() {
    return {};
  },
  methods: {
    async uploadAttach(param) {
      try {
        const name = param.file.name;
        const ext = name.substr(name.lastIndexOf(".") + 1);
        const urlData = await ContractApis.getUploadUrl(ext);
        const res = await axios.put(urlData.uploadPath, param.file, { headers: { "Content-Type": "" } });
        const fileData = {
          fileName: name,
          fileExt: ext,
          filePath: urlData.filePath,
          fileType: 4,
          fileSize: param.file.size,
          fileSource: "PC端",
          uploadUserName: this.$store.state.user.realName,
          creationTime: dateFormat(new Date(), "YYYY-MM-DD HH:mm:ss"),
        };
        this.$emit("uploaded", fileData);
        param.onSuccess(res);
      } catch (error) {
        console.error(error);
        param.onError(error);
      }
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.warning("文件大小不能超过50M!");
        return false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.uploader {
  margin-bottom: 10px;
}
</style>
